/// \file popupFormatter.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import React, { Fragment } from 'react';
import { SearchDropdownBar } from '../../../components/filter/searchDropdownBar';
import { MultiSelectDropdownBar } from '../../../components/filter/multiSelectDropdownBar';

export const PopupFormatter = (props:{
  id:string,
  pairs:any,
  onInputChange:(e:any)=>void,
}) => {
  const id = props.id;
  const pairs= props.pairs;
  const onInputChange = props.onInputChange;

  const onTimeClear = () => {
    console.log("Why is this getting triggered?");
  };

    return(
    <Fragment>
        <div className={id+"-contents"}>
            {pairs.map((pair:any, index:number) => <FilterElement key={pair.id+"-"+pair.name + index.toString()} id={id} pair={pair} onTimeClear={onTimeClear} onInput={onInputChange} />)}
        </div>
    </Fragment>
    );
};

function FilterElement(props:{
  pair:{
    style:string,
    name:string,
    title:string,
    values:{
      data:any[],
      onChange:(e:any)=>void,
      onFilterChange:(e:any)=>void,
      startValue:any,
      placeholder:string
    }
  },
  id:string,
  onTimeClear:null|((e:any)=>void),
  onInput:((e:any)=>void)
}) {
  const pair = props.pair;
  const id = props.id;
  const onTimeClear = props.onTimeClear;
  if(pair.style=="input"){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input className={id+"-input"} type="text" id={id+"-"+pair.name+"-input"} onChange={props.onInput}></input>
      </div>
    );
  }else if(pair.style=="password"){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input className={id+"-input"} type="password" id={id+"-"+pair.name+"-input"} onChange={props.onInput}></input>
        <button className={id+"-"+pair.name+" visibility-button k-icon k-i-preview strike"} id={id+"-"+pair.name} onClick={pair.values.onChange}></button>
      </div>
    );
  }
  else if(pair.style=="single-select"){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <SearchDropdownBar
          id = {id+"-"+pair.name+"-dropdown-combobox"}
          onFilterChange={pair.values.onFilterChange}
          onChange={pair.values.onChange}
          data={pair.values.data}
          value={pair.values.startValue}
          placeholder={pair.values.placeholder}
        />
      </div>
    );
  }else if(pair.style==`multi-select`){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <MultiSelectDropdownBar
        id = {id+"-"+pair.name+"-dropdown-combobox"}
        onFilterChange={pair.values.onFilterChange}
        onChange={pair.values.onChange}
        data={pair.values.data}
        value={pair.values.startValue}
        placeholder={pair.values.placeholder}
        />
      </div>
    );
  }else if(pair.style==`date-time` && onTimeClear!=null){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input type="datetime-local" className={id+"-input"} id={id+"-"+pair.name+"-input"} value={pair.values.startValue} onBlur={pair.values.onChange}></input>
        <button className={id+"-"+pair.name+"-clear-button"} onClick={(e:any)=>onTimeClear(e)}>X</button>
      </div>
    );
  }else if(pair.style==`tel` && onTimeClear!=null){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input type="tel" className={id+"-input"} id={id+"-"+pair.name+"-input"} onBlur={pair.values.onChange} placeholder="800-123-4567" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"></input>
      </div>
    );
  }else if(pair.style==`email` && onTimeClear!=null){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input type="email" className={id+"-input"} id={id+"-"+pair.name+"-input"} onBlur={pair.values.onChange} placeholder="username@mailserver.domain" pattern="^\S+@\S+\.\S+$"></input>
      </div>
    );
  }
  else{
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <h4>ERROR - {pair.style} Not Found</h4>
      </div>
      );
  }
}